import React from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'

import { isSelectedStyles, labelColor } from './calendarHelpers'
import { m } from '../utils'

const StyledDayContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`

const StyledArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid
    ${({ accordionColor, theme }) => accordionColor || theme.darkGrey};
  transform: translateY(0.7em);

  &.accordion-enter {
    height: auto;
  }

  &.accordion-enter-active {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme }) => theme.darkGrey};
    transition: 2.5s;
  }

  &.accordion-exit {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme }) => theme.darkGrey};
    transition: 2.5s;
  }

  &.accordion-exit-active {
    height: auto;
    transition: 2.5s;
  }
`

const StyledText = styled.div`
  position: relative;
  top: -5px;

  &.accordion-enter {
    opacity: 0;
  }

  &.accordion-enter-active {
    opacity: 1;
  }

  &.accordion-exit {
    opacity: 1;
  }

  &.accordion-exit-active {
    opacity: 0;
  }
`

const StyledDayLabel = styled.div`
  flex: 1;
  display: flex;
  width: 33px;
  height: 33px;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
  color: ${({ theme }) => theme.darkGrey}
  border-radius: 50%;

  font-weight: ${({ inMonth }) => (inMonth ? 500 : 500)};
  color: ${props => labelColor(props)};
  ${({ isSelected, theme, selectedColor = theme.darkGrey }) =>
    isSelectedStyles(isSelected, selectedColor)}
`

const CalendarDay = ({
  accordionColor,
  children,
  currentMonth,
  day,
  onDateSelect,
  handleDateClick,
  renderDay = () => {},
  selectedColor,
  selectedDates,
  selectedWeek,
  selectedShifts,
  todayColor,
  week,
  flexibleDates,
  cursor,
  moveCursorTo,
  available,
  ancestor
}) => {
  const dayString = day.toDate().toDateString();
  const isSelected = selectedDates.find(date => day.isSame(date, 'day'));
  const isOpen = (cursor === dayString && flexibleDates[cursor]) || isSelected
  const isArrow = cursor === dayString && flexibleDates[cursor] && selectedWeek === week && children
  const isAvailable = ancestor === 'book' ? Boolean(available[dayString]) : true;
  return (
    <StyledDayContainer>
      <StyledDayLabel
        onClick={() => onDateSelect(day) === 'select' ? handleDateClick(day, week) : (onDateSelect(day) === 'suggest' ? moveCursorTo(day, week) : null)}
        inMonth={day.isSame(currentMonth, 'month')}
        isSelected={isSelected || (cursor === dayString && flexibleDates[cursor])}
        isAvailable={isAvailable}
        isToday={day.isSame(m(), 'day')}
        selectedColor={isSelected ? selectedColor : (cursor === dayString && flexibleDates[cursor] ? "#414141" : selectedColor)}
        todayColor={todayColor}>
        {day.format('D')}
      </StyledDayLabel>
      {isOpen ? (
        <CSSTransition
          in={true}
          timeout={2500}
          classNames="accordion"
          unmountOnExit
          onExited={() => {}}>
          {isArrow ?
            <StyledArrow accordionColor={accordionColor} /> :
            <StyledText />
          }
        </CSSTransition>
      ) : (
          <CSSTransition
            in={true}
            timeout={2500}
            classNames="accordion"
            unmountOnExit
            onExited={() => {}}>
            <StyledText>{renderDay(day)}</StyledText>
          </CSSTransition>
        )}
    </StyledDayContainer>
  )
}

export default CalendarDay



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/CalendarDay.js